module.exports = __webpack_public_path__ + "img/home-11.cb9bfdc9.png";